import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import { Modal, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';
import SVG from 'react-inlinesvg';
import './AddCoworkersModal.scss';
import RoleChangeDropdown from './RoleChangeDropdown';
import AddCoworkersInput from '../common/AddCoworkersInput';
import CopyLink from '../common/CopyLink';
import { postRequest, putRequest, deleteRequest } from '../../requestUtils';
import userIcon from '../../../assets/images/user-icon.svg';
import copyLinkImg from '../../../assets/images/link-green.svg';
import { analyticsTrack } from '../../analyticsUtils';
var messagePlaceholder = 'Write a message to your colleagues';

// default role changes based on current user.
var defaultRoleSelection = function defaultRoleSelection(currentUser) {
  if (currentUser === null) return 'admin'; // Means currentUser is a rep.

  var level = currentUser.permissions_level;
  if (level === 'owner') {
    return 'admin';
  }
  return level;
};
var _isCurrentUser = function _isCurrentUser(teamMember, currentUser) {
  return currentUser && teamMember.permissions_object_id === currentUser.permissions_object_id;
};
var buildTeamMembersList = function buildTeamMembersList(teamMembers, currentUser) {
  if (currentUser === null) {
    return teamMembers;
  }
  var worklist = teamMembers.filter(function (teamMember) {
    return !_isCurrentUser(teamMember, currentUser);
  });
  worklist.push(currentUser);
  return worklist;
};
var renderErrorsList = function renderErrorsList(errorList) {
  return /*#__PURE__*/React.createElement("div", null, errorList.map(function (errorMessage, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "mt-8 error-messages",
      key: "".concat(errorMessage[0]).concat(index)
    }, /*#__PURE__*/React.createElement("i", {
      className: "me-3 fas fa-exclamation-triangle"
    }), errorMessage);
  }));
};
var AddCoworkersModal = /*#__PURE__*/function (_Component) {
  function AddCoworkersModal(props) {
    var _this;
    _classCallCheck(this, AddCoworkersModal);
    _this = _callSuper(this, AddCoworkersModal, [props]);
    var membersSerializer = _this.props.initialTeamMembers;
    var initCurrentUser = membersSerializer.current_user_permission;
    var teamMembers = buildTeamMembersList(membersSerializer.team_members, initCurrentUser);
    _this.state = {
      teamMembers: teamMembers,
      showModal: props.modalIsOpen,
      emails: [],
      optionalMessage: '',
      selectedInvitationRole: defaultRoleSelection(initCurrentUser),
      inviteErrors: [],
      roleChangeErrors: [],
      displayMessage: '',
      reminderSentPermissionIds: [],
      currentUser: initCurrentUser // currentUser is set iff the person looking at the modal
      // has permissions for the project. In many cases, reps
      // will not have permissions, in which case currentUser
      // will be null.
    };
    _this.sendInvitations = _this.sendInvitations.bind(_this);
    _this.handleEmailsChange = _this.handleEmailsChange.bind(_this);
    _this.handleOptionalMessageChange = _this.handleOptionalMessageChange.bind(_this);
    _this.handleHideModal = _this.handleHideModal.bind(_this);
    _this.handleShowModal = _this.handleShowModal.bind(_this);
    _this.handleInvitationRoleChange = _this.handleInvitationRoleChange.bind(_this);
    _this.handleMemberRoleChange = _this.handleMemberRoleChange.bind(_this);
    _this.handleMemberRemoval = _this.handleMemberRemoval.bind(_this);
    _this.handleSendReminder = _this.handleSendReminder.bind(_this);
    _this.handleClearDisplayMessage = _this.handleClearDisplayMessage.bind(_this);
    _this.isCurrentUser = _this.isCurrentUser.bind(_this);
    _this.canSendInvite = _this.canSendInvite.bind(_this);
    return _this;
  }
  _inherits(AddCoworkersModal, _Component);
  return _createClass(AddCoworkersModal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.modalIsOpen && this.props.modalIsOpen) {
        this.handleShowModal();
      }
    }
  }, {
    key: "onTimesheetPage",
    value: function onTimesheetPage() {
      return this.props.location === 'timesheet';
    }
  }, {
    key: "onProjectReviewPage",
    value: function onProjectReviewPage() {
      return this.props.location === 'project-review';
    }
  }, {
    key: "onProposalPage",
    value: function onProposalPage() {
      return this.props.location === 'proposal';
    }
  }, {
    key: "isCurrentUser",
    value: function isCurrentUser(teamMember) {
      return _isCurrentUser(teamMember, this.state.currentUser);
    }
  }, {
    key: "canSendInvite",
    value: function canSendInvite() {
      var _this$state = this.state,
        emails = _this$state.emails,
        selectedInvitationRole = _this$state.selectedInvitationRole;
      return emails.length > 0 && selectedInvitationRole.length > 0;
    }
  }, {
    key: "doesCurrentUserHaveLevel",
    value: function doesCurrentUserHaveLevel(level) {
      var currentUser = this.state.currentUser;
      return currentUser && currentUser.permissions_level === level;
    }
  }, {
    key: "isCurrentUserRep",
    value: function isCurrentUserRep() {
      return this.state.currentUser === null || this.state.currentUser.is_rep;
    }
  }, {
    key: "generateSubtitleCopy",
    value: function generateSubtitleCopy() {
      if (this.isCurrentUserRep()) {
        return ['As a Clora rep, you can edit the owner of this project from this page.', 'Inviting a new owner or promoting a current member to owner will automatically demote the current owner to Admin.', 'If you are the current owner, transferring ownership to someone else will demote you.'];
      }
      if (this.onTimesheetPage()) {
        return ["Approvers can view, approve, and request changes on this project's timesheets.", "Timesheets must be approved within 5 business days of the consultant's submission."];
      }
      if (this.onProjectReviewPage()) {
        return ['Coworkers wil be able to help you during the hiring process.', 'Invite and allow them to edit the project post, like and dislike', 'consultants and interview candidates.'];
      }
      if (this.onProposalPage()) {
        return ["When you share ".concat(this.props.consultantName, "'s proposal, your colleague will become a team member for this project.")];
      }
      return ['Ask colleagues to collaborate on this project and review candidates.'];
    }
  }, {
    key: "headingCopy",
    value: function headingCopy() {
      if (this.isCurrentUserRep()) {
        return 'Add collaborators to this project';
      }
      if (this.onProposalPage()) {
        return "Share ".concat(this.props.consultantName, "'s Proposal");
      }
      if (this.onProjectReviewPage() && this.props.pageSubmitted) {
        return 'Project submitted to Clora for review! Meanwhile add coworkers:';
      }
      return 'Invite to Project';
    }
  }, {
    key: "generateTooltipCopy",
    value: function generateTooltipCopy() {
      if (this.doesCurrentUserHaveLevel('manager')) {
        return 'As a Manager, you can only grant Manager and Collaborator access levels to your colleagues.';
      }
      if (this.doesCurrentUserHaveLevel('invoice_approver')) {
        return 'As a Timesheet Approver, you can only grant the Timesheet Approver access level to your colleagues.';
      }
      if (this.doesCurrentUserHaveLevel('collaborator')) {
        return 'As a Collaborator, you can only grant the Collaborator access level to your colleagues.';
      }
      return null;
    }
  }, {
    key: "handleClearDisplayMessage",
    value: function handleClearDisplayMessage() {
      var _this2 = this;
      setTimeout(function () {
        _this2.setState({
          displayMessage: ''
        });
      }, 6000);
    }
  }, {
    key: "handleHideModal",
    value: function handleHideModal() {
      this.props.hideModalCallback();
      this.setState({
        showModal: false,
        inviteErrors: [],
        roleChangeErrors: [],
        optionalMessage: ''
      });
    }
  }, {
    key: "handleShowModal",
    value: function handleShowModal() {
      this.props.showModalCallback();
      this.setState({
        showModal: true,
        inviteErrors: [],
        roleChangeErrors: [],
        optionalMessage: ''
      });
    }
  }, {
    key: "handleEmailsChange",
    value: function handleEmailsChange(newEmails) {
      this.setState({
        emails: newEmails
      });
    }
  }, {
    key: "handleOptionalMessageChange",
    value: function handleOptionalMessageChange(newMessage) {
      this.setState({
        optionalMessage: newMessage
      });
    }
  }, {
    key: "handleInvitationRoleChange",
    value: function handleInvitationRoleChange(newRole) {
      this.setState({
        selectedInvitationRole: newRole
      });
    }
  }, {
    key: "sendInvitations",
    value: function sendInvitations() {
      var _this3 = this;
      if (!this.canSendInvite()) {
        return;
      }
      var _this$state2 = this.state,
        emails = _this$state2.emails,
        optionalMessage = _this$state2.optionalMessage,
        selectedInvitationRole = _this$state2.selectedInvitationRole;
      var _this$props = this.props,
        csrfToken = _this$props.csrfToken,
        basePermissionsUrl = _this$props.basePermissionsUrl,
        location = _this$props.location,
        proposalResourceId = _this$props.proposalResourceId;
      var params = {
        emails: emails,
        level: selectedInvitationRole,
        message: optionalMessage,
        proposal_resource_id: proposalResourceId
      };
      postRequest(basePermissionsUrl, params, csrfToken).then(function (response) {
        var newTeamMembers = buildTeamMembersList(response.data.project.team_members, response.data.project.current_user_permission);
        analyticsTrack("Sending member invites to ".concat(emails.join(', '), " from team modal"), {
          location: _this3.onProjectReviewPage() ? 'Project creation' : location || 'Project View'
        });
        _this3.setState({
          emails: [],
          optionalMessage: '',
          selectedInvitationRole: defaultRoleSelection(_this3.state.currentUser),
          teamMembers: newTeamMembers,
          inviteErrors: response.data.errors,
          roleChangeErrors: [],
          currentUser: response.data.project.current_user_permission,
          displayMessage: "".concat(newTeamMembers.length === 0 ? 'Team' : "".concat(newTeamMembers.length, " team"), " member successfully added to project")
        });
        _this3.handleClearDisplayMessage();
      });
    }
  }, {
    key: "handleMemberRoleChange",
    value: function handleMemberRoleChange(teamMember, newRole) {
      var _this4 = this;
      var _this$props2 = this.props,
        csrfToken = _this$props2.csrfToken,
        basePermissionsUrl = _this$props2.basePermissionsUrl;
      var projectPermissionId = teamMember.permissions_object_id;
      var url = "".concat(basePermissionsUrl, "/").concat(projectPermissionId);
      var params = {
        level: newRole
      };
      putRequest(url, params, csrfToken).then(function (response) {
        var newTeamMembers = buildTeamMembersList(response.data.project.team_members, response.data.project.current_user_permission);
        _this4.setState({
          teamMembers: newTeamMembers,
          inviteErrors: [],
          roleChangeErrors: response.data.errors,
          currentUser: response.data.project.current_user_permission
        });
      });
    }
  }, {
    key: "handleMemberRemoval",
    value: function handleMemberRemoval(teamMember) {
      var _this5 = this;
      var _this$props3 = this.props,
        csrfToken = _this$props3.csrfToken,
        basePermissionsUrl = _this$props3.basePermissionsUrl;
      var projectPermissionId = teamMember.permissions_object_id;
      var url = "".concat(basePermissionsUrl, "/").concat(projectPermissionId);
      deleteRequest(url, csrfToken).then(function (_ref) {
        var data = _ref.data;
        var newTeamMembers = buildTeamMembersList(data.project.team_members, data.project.current_user_permission);
        _this5.setState({
          teamMembers: newTeamMembers,
          inviteErrors: [],
          roleChangeErrors: [],
          currentUser: data.project.current_user_permission,
          displayMessage: data.message
        });
        _this5.handleClearDisplayMessage();
      });
    }
  }, {
    key: "handleSendReminder",
    value: function handleSendReminder(teamMember, event) {
      var _this6 = this;
      var _this$props4 = this.props,
        csrfToken = _this$props4.csrfToken,
        basePermissionsUrl = _this$props4.basePermissionsUrl,
        proposalResourceId = _this$props4.proposalResourceId;
      event.preventDefault();
      var projectPermissionId = teamMember.permissions_object_id;
      var url = "".concat(basePermissionsUrl, "/").concat(projectPermissionId, "/reminder");
      postRequest(url, {
        proposal_resource_id: proposalResourceId
      }, csrfToken).then(function () {
        return _this6.setState(function (prevState) {
          return {
            reminderSentPermissionIds: _toConsumableArray(new Set([].concat(_toConsumableArray(prevState.reminderSentPermissionIds), [projectPermissionId])))
          };
        });
      });
    }
  }, {
    key: "renderAddCoworkersInput",
    value: function renderAddCoworkersInput() {
      var invitableRoles = this.props.invitableRoles;
      var _this$state3 = this.state,
        optionalMessage = _this$state3.optionalMessage,
        emails = _this$state3.emails,
        selectedInvitationRole = _this$state3.selectedInvitationRole,
        inviteErrors = _this$state3.inviteErrors;
      return /*#__PURE__*/React.createElement(AddCoworkersInput, {
        emails: emails,
        onChangeEmails: this.handleEmailsChange,
        invitableRoles: invitableRoles,
        selectedRole: selectedInvitationRole,
        onChangeSelectedRole: this.handleInvitationRoleChange,
        withMessage: true,
        errors: inviteErrors,
        message: optionalMessage,
        placeholder: messagePlaceholder,
        onChangeMessage: this.handleOptionalMessageChange
      });
    }
  }, {
    key: "renderSubmitButton",
    value: function renderSubmitButton() {
      return /*#__PURE__*/React.createElement("div", {
        className: "send-invites-button-container"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: this.sendInvitations,
        variant: "primary",
        className: "mb-0 submit-invites-button".concat(this.canSendInvite() ? '-populated' : ''),
        disabled: !this.canSendInvite()
      }, this.onProposalPage() ? 'Share Proposal' : 'Send invite to collaborate'));
    }
  }, {
    key: "renderAddCoworkersSection",
    value: function renderAddCoworkersSection() {
      var copyLink = this.props.copyLink;
      var subtitleCopy = this.generateSubtitleCopy();
      var tooltipCopy = this.generateTooltipCopy();
      var tooltip = function tooltip() {
        return /*#__PURE__*/React.createElement(OverlayTrigger, {
          placement: "right",
          delay: {
            show: 100
          },
          overlay: /*#__PURE__*/React.createElement(Tooltip, {
            id: "access-level-tooltip"
          }, tooltipCopy)
        }, /*#__PURE__*/React.createElement("i", {
          className: "ms-3 fas fa-info-circle"
        }));
      };
      return /*#__PURE__*/React.createElement("div", {
        className: "add-coworkers-modal-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "add-coworkers-header"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "add-coworkers-modal-section-title"
      }, this.headingCopy(), tooltipCopy && tooltip()), copyLink && /*#__PURE__*/React.createElement("div", {
        className: "add-coworkers-copy-link"
      }, /*#__PURE__*/React.createElement(SVG, {
        src: copyLinkImg,
        alt: "User Icon",
        className: "user-icon"
      }), /*#__PURE__*/React.createElement(CopyLink, {
        url: copyLink,
        shortForm: true,
        linkText: "Copy Link"
      }))), this.onProjectReviewPage() || this.onProposalPage() ? /*#__PURE__*/React.createElement("div", {
        className: "mb-4"
      }, subtitleCopy.join(' ')) : /*#__PURE__*/React.createElement("ul", {
        className: "ps-3 mb-4"
      }, subtitleCopy.map(function (copy) {
        return /*#__PURE__*/React.createElement("li", {
          key: copy
        }, copy);
      })), this.renderAddCoworkersInput(), this.renderSubmitButton());
    }

    // for changing the role of an existing coworker
  }, {
    key: "renderRoleChangeDropdown",
    value: function renderRoleChangeDropdown(teamMember) {
      var _this7 = this;
      var _this$props5 = this.props,
        invitableRoles = _this$props5.invitableRoles,
        editableRoles = _this$props5.editableRoles;

      /*
        IMPORTANT DISTINCTION: invitableRoles vs editableRoles
         invitableRoles: the roles I am able to change somebody else to.
        editableRoles: I can edit the permissions of people with these roles.
      */

      /*
         What this mess is trying to say is the current user can change the given team member's role
         if all of these conditions hold:
         1. The team member in question is not an owner (no one is allowed to directly change
            the owner, even reps). Directly changing the owner can lead to bad things happening,
            as we have found out. So we're not even going to let that be a possibility.
          2. The team member in question has a role which can be edited by the current user
            (calculated by user#editable_roles_for and passed in as the prop editableRoles)
          3. The team member in question is not the current user (i.e. you can't edit yourself).
            Reps are exempt from this rule - they can change their own role on a project,
            or even remove themselves.
      */
      var currentUserIsAllowedToChangeRole = teamMember.permissions_level !== 'owner' && editableRoles.includes(teamMember.permissions_level) && (!this.isCurrentUser(teamMember) || this.isCurrentUserRep());
      var onChange = function onChange(newRole) {
        return _this7.handleMemberRoleChange(teamMember, newRole);
      };
      var handleRemove = function handleRemove() {
        return _this7.handleMemberRemoval(teamMember);
      };
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RoleChangeDropdown, {
        permissionOptions: invitableRoles,
        enabled: currentUserIsAllowedToChangeRole,
        onChange: onChange,
        value: teamMember.permissions_level,
        showRemoveOption: true,
        handleRemove: handleRemove
      }));
    }
  }, {
    key: "renderTeamMemberName",
    value: function renderTeamMemberName(teamMember) {
      var text = '';
      if (!teamMember.name) {
        text = teamMember.email;
      } else if (this.isCurrentUser(teamMember)) {
        text = 'You';
      } else {
        text = teamMember.name;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "user-name"
      }, text);
    }
  }, {
    key: "renderTeamMemberEmail",
    value: function renderTeamMemberEmail(teamMember) {
      var _this8 = this;
      var reminderSentPermissionIds = this.state.reminderSentPermissionIds;
      if (teamMember.name) {
        return /*#__PURE__*/React.createElement("div", {
          className: "user-email"
        }, teamMember.email);
      }
      var canSendReminder = this.props.editableRoles.includes(teamMember.permissions_level);
      return /*#__PURE__*/React.createElement("div", {
        className: "user-email"
      }, "Pending...", canSendReminder && (reminderSentPermissionIds.includes(teamMember.permissions_object_id) ? /*#__PURE__*/React.createElement("span", {
        className: "ms-2"
      }, "Reminder sent!") : /*#__PURE__*/React.createElement("a", {
        tabIndex: 0,
        role: "button",
        className: "send-reminder-button ms-2",
        onClick: function onClick(e) {
          return _this8.handleSendReminder(teamMember, e);
        }
      }, "Send reminder")));
    }
  }, {
    key: "renderProjectMembersTable",
    value: function renderProjectMembersTable() {
      var _this9 = this;
      var teamMembers = this.state.teamMembers;
      return /*#__PURE__*/React.createElement("table", {
        className: "project-members-table",
        width: "100%"
      }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", {
        className: "with-border"
      }, /*#__PURE__*/React.createElement("th", {
        className: "first-heading pb-3"
      }, "Users"), /*#__PURE__*/React.createElement("th", null, "Project access level")), teamMembers.map(function (teamMember) {
        return /*#__PURE__*/React.createElement("tr", {
          className: "with-border",
          key: "".concat(teamMember.permissions_object_id).concat(teamMember.permissions_level),
          id: "team-member-entry-".concat(teamMember.email)
        }, /*#__PURE__*/React.createElement("td", {
          className: "py-3"
        }, _this9.renderTeamMemberName(teamMember), _this9.renderTeamMemberEmail(teamMember)), /*#__PURE__*/React.createElement("td", null, _this9.renderRoleChangeDropdown(teamMember)));
      })));
    }
  }, {
    key: "renderProjectMembersSection",
    value: function renderProjectMembersSection() {
      var _this$state4 = this.state,
        teamMembers = _this$state4.teamMembers,
        roleChangeErrors = _this$state4.roleChangeErrors;
      return /*#__PURE__*/React.createElement("div", {
        className: "add-coworkers-modal-content"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "add-coworkers-modal-section-title"
      }, "Hiring Team (", teamMembers.length, ")"), /*#__PURE__*/React.createElement("div", {
        className: "mt-2 mb-5"
      }, renderErrorsList(roleChangeErrors)), this.renderProjectMembersTable());
    }
  }, {
    key: "renderModal",
    value: function renderModal() {
      var _this$props6 = this.props,
        invitableRoles = _this$props6.invitableRoles,
        pageSubmitted = _this$props6.pageSubmitted;
      var displayMessage = this.state.displayMessage;
      var ableToAddCoworkers = invitableRoles.length > 0;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Modal, {
        show: this.state.showModal,
        onHide: this.handleHideModal,
        dialogClassName: "add-coworkers-modal",
        size: "lg"
      }, /*#__PURE__*/React.createElement("div", {
        className: "add-coworkers-modal-size"
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }), ableToAddCoworkers && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Modal.Body, {
        className: "add-coworkers-modal-body"
      }, this.renderAddCoworkersSection(), displayMessage && /*#__PURE__*/React.createElement("div", {
        className: "success-message"
      }, displayMessage)), /*#__PURE__*/React.createElement("hr", {
        className: "mt-0"
      })), /*#__PURE__*/React.createElement("div", {
        className: "add-coworkers-modal-body"
      }, this.renderProjectMembersSection(), pageSubmitted && /*#__PURE__*/React.createElement("div", {
        className: "mt-3 skip-coworkers-container"
      }, /*#__PURE__*/React.createElement("a", {
        tabIndex: 0,
        role: "button",
        className: "skip-coworkers-button",
        onClick: this.handleHideModal,
        id: "skip-link"
      }, "Skip"))))));
    }
  }, {
    key: "renderMemberIcons",
    value: function renderMemberIcons() {
      var teamMembers = this.state.teamMembers;

      // Render max 3 icons to limit space taken up.
      return /*#__PURE__*/React.createElement("div", {
        className: "team-member-icons"
      }, teamMembers.slice(0, 3).map(function (teamMember, index) {
        return /*#__PURE__*/React.createElement("div", {
          className: "user-div",
          key: teamMember.permissions_object_id || 0,
          style: {
            left: "".concat(index * -5, "px")
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "user-name"
        }, teamMember.name ? teamMember.name_initials : teamMember.email.charAt(0).toUpperCase()));
      }));
    }
  }, {
    key: "renderModalButton",
    value: function renderModalButton() {
      var teamMembers = this.state.teamMembers;
      var _this$props7 = this.props,
        newShareButton = _this$props7.newShareButton,
        buttonEnabled = _this$props7.buttonEnabled,
        location = _this$props7.location,
        showNewProposalUX = _this$props7.showNewProposalUX;
      var numMembers = teamMembers.length;
      var clickAction = buttonEnabled ? this.handleShowModal : undefined;
      var linkStyle = this.onTimesheetPage() || this.onProjectReviewPage();
      var buttonClass = "mb-0 ".concat(linkStyle ? 'add-coworkers-link' : 'add-coworkers-button', " ").concat(!buttonEnabled ? 'disabled' : '', " ").concat(!newShareButton ? 'msg h-3' : '');
      if (showNewProposalUX) {
        return /*#__PURE__*/React.createElement("div", {
          className: "add-coworkers-modal-entry  medium-weight"
        }, /*#__PURE__*/React.createElement("span", {
          className: "me-3"
        }, "Hiring Team"), this.renderMemberIcons());
      }
      var renderActionButton = function renderActionButton() {
        if (location === 'next-steps-component') return null;
        if (newShareButton) {
          return /*#__PURE__*/React.createElement("a", {
            role: "button",
            tabIndex: 0,
            onClick: clickAction,
            className: "new-share-button",
            disabled: !buttonEnabled
          }, /*#__PURE__*/React.createElement(SVG, {
            src: userIcon,
            alt: "User Icon",
            className: "user-icon"
          }), /*#__PURE__*/React.createElement("span", null, "Collaborators"), /*#__PURE__*/React.createElement("span", null, "(", numMembers, ")"));
        }
        if (linkStyle) {
          return /*#__PURE__*/React.createElement("a", {
            role: "button",
            tabIndex: 0,
            onClick: clickAction,
            className: buttonClass,
            disabled: !buttonEnabled
          }, /*#__PURE__*/React.createElement("i", {
            className: "fa fa-plus ms-5 me-2"
          }), "Add interviewers");
        }
        return /*#__PURE__*/React.createElement(Button, {
          variant: "primary",
          onClick: clickAction,
          className: buttonClass,
          disabled: !buttonEnabled
        }, "Share");
      };
      return /*#__PURE__*/React.createElement("div", {
        className: "add-coworkers-modal-entry ".concat(linkStyle ? 'left-justify' : '', " medium-weight ").concat(linkStyle ? 'body-text-2' : '')
      }, !newShareButton && location !== 'next-steps-component' && this.renderMemberIcons(), !newShareButton && location !== 'next-steps-component' && /*#__PURE__*/React.createElement("a", {
        role: "button",
        tabIndex: 0,
        onClick: clickAction,
        className: "body-text-2 member-count ms-2"
      }, numMembers, ' ', numMembers === 1 ? 'member' : 'members'), renderActionButton());
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, this.renderModalButton(), this.renderModal());
    }
  }]);
}(Component);
AddCoworkersModal.propTypes = {
  initialTeamMembers: PropTypes.shape({
    team_members: PropTypes.arrayOf(PropTypes.shape({}))
  }),
  invitableRoles: PropTypes.arrayOf(PropTypes.string),
  editableRoles: PropTypes.arrayOf(PropTypes.string),
  csrfToken: PropTypes.string.isRequired,
  basePermissionsUrl: PropTypes.string.isRequired,
  location: PropTypes.string,
  buttonEnabled: PropTypes.bool,
  showModalCallback: PropTypes.func,
  hideModalCallback: PropTypes.func,
  modalIsOpen: PropTypes.bool,
  pageSubmitted: PropTypes.bool,
  newShareButton: PropTypes.bool,
  consultantName: PropTypes.string,
  proposalResourceId: PropTypes.string,
  copyLink: PropTypes.string,
  showNewProposalUX: PropTypes.bool
};
AddCoworkersModal.defaultProps = {
  initialTeamMembers: [],
  invitableRoles: [],
  editableRoles: [],
  location: '',
  buttonEnabled: true,
  hideModalCallback: function hideModalCallback() {},
  showModalCallback: function showModalCallback() {},
  modalIsOpen: false,
  pageSubmitted: false,
  newShareButton: false,
  consultantName: '',
  proposalResourceId: null,
  copyLink: null,
  showNewProposalUX: false
};
export default AddCoworkersModal;